export default "__VITE_ASSET__Cws_2vZe__"